








import { AppModule} from '@/store/modules/app'
import Vue from 'vue'
import {Prop, Component} from 'vue-property-decorator'

@Component({
    name: "gift-options-button"
})
export default class GiftOptionsButton extends Vue{
    @Prop({}) private isMobile: boolean | undefined
    
    goToGiftoptions(): void {
        AppModule.SetShowGiftOptions(true)
    }

    get allStepsCompleted(): boolean {
        return AppModule.allStepsCompleted;
    }

}
